import { defineStore } from "pinia";

type BusinessState = Partial<{
  showForm: boolean;
}>;

const defaultState: BusinessState = {
  showForm: false,
};

export const useGlobalStore = defineStore("login", {
  state: (): BusinessState => ({ ...defaultState }),
  actions: {
    showLoginForm(_showForm: boolean) {
      this.showForm = _showForm;
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: "login",
        paths: ["showLoginForm"],
      },
    ],
  },
});
